import {initReactI18next} from "react-i18next";
import i18next from "i18next";

import en from './translation/en.json'
import ru from './translation/ru.json'

i18next
    .use(initReactI18next)
    .init({
        debug: true,
        fallbackLng: "en",
        resources: {
            en: {translation: en},
            ru: {translation: ru}
        }
    })